import Utils from "../../../shared/utils";

export const FILTER_IMAGE = Utils.buildNewsletterLink("icons/filter-icon.svg");
